var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSolid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_14936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.25 16C29.1065 16 30.887 15.2625 32.1997 13.9497C33.5125 12.637 34.25 10.8565 34.25 9C34.25 7.14348 33.5125 5.36301 32.1997 4.05025C30.887 2.7375 29.1065 2 27.25 2C25.3935 2 23.613 2.7375 22.3003 4.05025C20.9875 5.36301 20.25 7.14348 20.25 9C20.25 10.8565 20.9875 12.637 22.3003 13.9497C23.613 15.2625 25.3935 16 27.25 16ZM24.7508 18.625C19.3641 18.625 15 22.9891 15 28.3758C15 29.2727 15.7273 30 16.6242 30H37.8758C38.7727 30 39.5 29.2727 39.5 28.3758C39.5 22.9891 35.1359 18.625 29.7492 18.625H24.7508Z",
    fill: "#AA182C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_148_14936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9716 15.9674C16.089 15.9674 18.1197 15.1263 19.617 13.629C21.1142 12.1318 21.9554 10.1011 21.9554 7.98366C21.9554 5.86624 21.1142 3.83554 19.617 2.33829C18.1197 0.841045 16.089 -9.91821e-05 13.9716 -9.91821e-05C11.8542 -9.91821e-05 9.82346 0.841045 8.32621 2.33829C6.82897 3.83554 5.98782 5.86624 5.98782 7.98366C5.98782 10.1011 6.82897 12.1318 8.32621 13.629C9.82346 15.1263 11.8542 15.9674 13.9716 15.9674ZM11.1211 18.9613C4.97738 18.9613 0 23.9387 0 30.0825C0 31.1054 0.829563 31.935 1.85248 31.935H26.0907C27.1136 31.935 27.9432 31.1054 27.9432 30.0825C27.9432 23.9387 22.9658 18.9613 16.822 18.9613H11.1211Z",
    fill: "#CC7480"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_14936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 28,
    fill: "white",
    transform: "translate(15 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_148_14936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9432,
    height: 31.9351,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolid2);
export default __webpack_public_path__ + "static/media/user-solid-2.9f38d91d53a73abec9b936bf6b988e9b.svg";
export { ForwardRef as ReactComponent };